<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import { getList, add, del, update, getDetails } from "@/api/finance/b2b_charging_type";
import cTable from "@/base/common/index";
import { getCompanies } from "@/api/user/client";
export default {
  name: "b2b_charging_type",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        getDetails,
        del,
        add,
        update,
				getList
      },
      footer: {
        show: () => false,
      },
      config: {
        height: 630,
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
								this.$page.handleRequestMethods('getList').then(res=>{
									this.$page.list = res.payload
								})
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              title: this.$t("handle"),
            },
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              title: [
                {
                  required: true,
                  message: "title cannot be empty",
                  trigger: "blur",
                },
              ],
              code: [
                {
                  required: true,
                  message: "code cannot be empty",
                  trigger: "blur",
                },
              ],
              affect_field: [
                {
                  required: true,
                  message: "affect_field cannot be empty",
                  trigger: "blur",
                },
              ],
              enable: [
                {
                  required: true,
                  type: "number",
                  message: "enable cannot be empty",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            { title: 24 },
            { code: 24 },
            { def_value: 24 },
            { affect_field: 24 },
            { sort: 24 },
            { enable: 24 },
            { remarks: 24 },
          ],
          fields: [
            {
              name: () => this.$t("zhTitle"),
              key: "title",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("zhTitle");
              },
            },
            {
              name: () => this.$t("contraband_code"),
              key: "code",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("code");
              },
            },
            {
              name: () => this.$t("def")+this.$t('number'),
              key: "def_value",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("def")+this.$t('number');
              },
            },
            {
              name: () =>this.$t("mapping1")+this.$t('Billing')+this.$t('field'),
              key: "affect_field",
              component: "Input",
              placeholder() {
                return this.$t("enter") +this.$t("mapping1")+this.$t('Billing')+this.$t('field');
              },
            },
						{
						  name: () => this.$t("Remarks"),
						  key: "remarks",
						  component: "Input",
						  placeholder: () => this.$t("enter") + this.$t("Remarks"),
						  bind: {
						    rows: 3,
						    type: "textarea",
						  },
						},
            {
              name: () => this.$t("exlType"),
              key: "enable",
              component: "Radio",
              options: [
								{label:this.$t('enable'),value:1},
								{label:this.$t('disable'),value:2},
							],
              bind: {
                border: true,
              },
              default: 1,
            },
            {
              name: () => this.$t("sort"),
              key: "sort",
              component: "InputNumber",
              placeholder() {
                return this.$t("enter") + this.$t("sort");
              },
              bind: {
                step: 1,
                min: 0,
                style: {
                  width: "100%",
                },
              },
              default: 0,
            },
          ],
        },
      },
      header: {
        searchs: [],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning",
              },
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
        },
				{
				  name: () => this.$t("zhTitle"),
				  key: "title",
					minWidth: 130,
				},
				{
				  name: () => this.$t("contraband_code"),
				  key: "code",
					minWidth: 130,
				},
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 150,
        },
        {
          name: () => this.$t("createUser"),
          key: "operator_name",
          width: 130,
        },
        
        {
          name: () => this.$t("exlType"),
          key: "enable",
          width: 80,
          methods: {
            render({ value }) {
              return value == 1?this.$t('enable'):this.$t('disable')
            },
          },
        },
        {
          name: () => this.$t("def")+this.$t('number'),
          key: "def_value",
          width: 130,
        },
        {
          name: () => this.$t("mapping1")+this.$t('Billing')+this.$t('field'),
          key: "affect_field",
					width: 130,
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
					width: 130,
        },
        {
          name: () => this.$t("sort"),
          key: "sort",
          width: "80",
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
            },
          ],

          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then((res) => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload);
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
										this.handleRequestMethods('getList').then(res=>{
											this.list = res.payload
										})
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
  mounted() {
		getList().then(res=>{
			if(res.data.status){
				this.$refs['table'].list = res.data.payload
			}
		})
    this.header.searchs.forEach(async (item) => {
      if (item.key === "country_id")
        item.options = (await getCountry()).data.payload.rows;
    });
  },
};
</script>
